
export const tagPreset = {
      extend: { 
        inactive: { background: 'rgba(148, 148, 148, 0.2)', color: '#949494'},
        reseller: { background: '#4A148C', color: '#FFFFFF' }
      },
      css: ({ dt }: any) => `
        .p-tag-inactive {
          background: ${dt('tag.inactive.background')};
          color: ${dt('tag.inactive.color')};
        }

        .p -tag-reseller {
          background: ${dt('tag.reseller.background')};
          color: ${dt('tag.reseller.color')};
        }
      `,
    }